// extracted by mini-css-extract-plugin
export default {"quiz_result_title":"result_quiz_result_title__z4Kr-","quiz_result_description":"result_quiz_result_description__ifIEy"};